import { apiClient } from "../config/api.config";
import {
  CreateSecretaryPayload,
  UpdateSecretaryPayload,
} from "../types/secretary.definition";

export function getSecretaryById(secretaryId: string) {
  return apiClient.request({
    method: "get",
    url: `/secretaries/${secretaryId}`,
  });
}

export function updateSecretary(
  secretaryId: string,
  data: Partial<UpdateSecretaryPayload>
) {
  return apiClient.request({
    method: "put",
    url: `/secretaries/${secretaryId}`,
    data,
  });
}

export function getAllFacilitySecretaries(facilityId: string) {
  return apiClient.request({
    method: "get",
    url: `/healthcare-facilities/${facilityId}/secretaries`,
  });
}

export function createSecretary(data: CreateSecretaryPayload) {
  return apiClient.request({
    method: "post",
    url: `/secretaries/register`,
    data,
  });
}

export function deleteSecretary(secretaryId: string) {
  return apiClient.request({
    method: "delete",
    url: `/secretaries/${secretaryId}`,
  });
}

export function assignSecretaryToFacility(
  secretaryId: string | number,
  facilityId: string | number
) {
  return apiClient.request({
    method: "post",
    url: `/secretaries/${secretaryId}/assign-healthcare-facility/${facilityId}`,
  });
}

export function unassignSecretaryFromFacility(
  secretaryId: string | number,
  facilityId: string | number
) {
  return apiClient.request({
    method: "delete",
    url: `/secretaries/${secretaryId}/unassign-healthcare-facility/${facilityId}`,
  });
}
